import menuUtil from '../../static/js/menuUtil'

import compileVariableUtil from '../../static/js/compileVariableUtil'
import templateUtil from '../../static/js/templateUtil'
import objectUtil from '../../static/js/objectUtil'

var menuCommon = {
  methods: {
    /**
        根据表达式计算返回结果
       * @param {String} express 表达式
       * @param {String} formData 数据
       * @param defaultValue 默认为true
        * @param {object} extendData 扩展属性
       *
       * @return {boolean}  返回是或否
      */
    computeExpress(express, formData, defaultValue = true, extendData = null) {
      // if (this.GLOBAL.isDebug) console.log("computeExpress", express);
      if (express === null || express === undefined || express === '') {
        // if (this.GLOBAL.isDebug) console.log("computeExpress:defaultValue",
        //   defaultValue);
        return defaultValue
      } else {
        //  if (this.GLOBAL.isDebug) console.log("computeExpress", express);
        var data = compileVariableUtil.getCompileVariable(formData, this, extendData)
        var returnData = templateUtil.compileData(express, data)
        // if (this.GLOBAL.isDebug) console.log("computeExpress:returnData",
        //   returnData);
        return returnData
      }
    },
    /****
     * 根据表达式判断是否显示按钮组
     * 用于在按钮菜单中的按钮配置了显示表达式，都不满足的情况下显示一个空白弹窗
     * @param {String} rowMenus 配置的数组
     * @param {String} formData 数据
     * @param defaultValue 默认为true
     * @param {object} extendData 扩展属性
     *
     * @return {boolean}  返回是或否
     */
    computeShowButtons(rowMenus, formData, defaultValue, extendData) {
      for (const rowMenu of rowMenus) {
        if (this.computeExpress(rowMenu.showExp, formData, defaultValue, extendData)) {
          return true
        }
      }
      return false
    },
  },
}

/**
编辑页面，按钮点击事件。
*/
var crudEditMenuClick = {
  methods: {
    // 前置动作
    handleMenuClickActionBefore(rowMenu, data) {
      return new Promise((resolve) => {
        let beforeAction = rowMenu.beforeAction ? menuUtil.typeMethod[rowMenu.beforeAction] : null
        if (!beforeAction) {
          resolve(data)
          return false
        } else {
          let beforeRowMenu = {
            param: rowMenu.beforeProperty,
            requestParam: rowMenu.beforeParameter,
          }
          var that = this.parentVue ? this.parentVue : this
          const actionSuccess = function (res) {
            data.responseBefore = res
            resolve(data)
          }
          const actionError = function (res) {
            if (res) that.responseData = res.data
          }
          let beforePromise = beforeAction(this, beforeRowMenu, data, actionSuccess, actionError)
          if (beforePromise) beforePromise.then(actionSuccess).catch(actionError)
        }
      })
    },
    // 菜单动作执行成功后，回调钩子函数
    handleMenuClickActionAfter(rowMenu, compileVariableData) {
      // if (!rowMenu.afterAction) return;
      // var afterActionDef = this.getAfterActionDef();
      // var afterActionFN = afterActionDef[rowMenu.afterAction];
      // if (typeof afterActionFN == 'function') {
      //     afterActionFN(rowMenu, compileVariableData, res);
      // }
      let afterAction = rowMenu.afterAction ? menuUtil.typeMethod[rowMenu.afterAction] : null
      if (!afterAction) {
        return false
      }
      let afterRowMenu = {
        param: rowMenu.afterProperty,
        requestParam: rowMenu.afterParameter,
      }
      var that = this.parentVue ? this.parentVue : this
      const actionSuccess = function (res) {
        compileVariableData.responseAfter = res
      }
      const actionError = function (res) {
        if (res) that.responseData = res.data
      }
      let afterPromise = afterAction(
        this,
        afterRowMenu,
        compileVariableData,
        actionSuccess,
        actionError
      )
      if (afterPromise) afterPromise.then(actionSuccess).catch(actionError)
    },

    handleMenuClick(rowMenu, extendData = null) {
      var fn = menuUtil.typeMethod[rowMenu.type]
      // console.log("handleMenuClick", rowMenu, fromData, res);
      if (!fn) {
        // console.error("该类型操作还未定义：rowMenu.type=" + rowMenu.type);
        alert('该类型操作还未定义：rowMenu.type=' + rowMenu.type)
        return
      }

      var data = compileVariableUtil.getCompileVariable(this.formData, this, extendData)
      var that = this.parentVue ? this.parentVue : this
      var successFn = () => {
        this.handleMenuClickActionBefore(rowMenu, data).then((compileVariableData) => {
          const fnSuccess = (res) => {
            compileVariableData.response = res
            if (res && res.data && res.data.data && res.data.code) {
              compileVariableData.responseData = res.data.data
            }
            // 刷新当前对象。
            if (
              rowMenu.type == 'submitFormData' ||
              rowMenu.type == 'saveFormData' ||
              rowMenu.type == 'handleSubmitFormDataBefore'
            ) {
              if (
                res.data.data &&
                !Array.isArray(res.data.data) &&
                // #6643, 新增判断条件 typeof res.data.data !== 'string'
                typeof res.data.data !== 'string'
              ) {
                // 解决为数组的情况也赋值给表单
                //解决保存后刷新页面数据发生变化
                let tempFormData = res.data.data
                let id =
                  objectUtil.getValueByPath(
                    tempFormData,
                    rowMenu.param?.orderIdKey ?? 'order.id'
                  ) || tempFormData?.id
                if (
                  rowMenu.type == 'saveFormData' &&
                  !that.onSide &&
                  id &&
                  id !== that.$route.query.id
                ) {
                  const query = { id }
                  if (that.$route.query?.way) {
                    query.way = that.$route.query.way
                  }
                  that.$router.replace({
                    name: that.$route.name,
                    query: query,
                  })
                } else if (that.getOfEditSuccess) {
                  that.getOfEditSuccess(res)
                } else {
                  that.formData = res.data.data
                  that.responseData = res.data
                }
              }
              // 解决新建提交后，返回id数据
              compileVariableData.data = that.formData
              if (that.$store.state.menuStore) {
                var currentRouter = that.$store.state.menuStore.currentRouter
                if (currentRouter && currentRouter.id) {
                  setTimeout(() => {
                    // 在侧滑调用的时候不能关闭本页面，因为访问不到$router,fpr
                    if (that.onSide) {
                      return
                    }
                    that.$store.commit('clearFormModifyBy', currentRouter.id)
                  }, 0)
                }
              }
            }
            this.handleMenuClickActionAfter(rowMenu, compileVariableData, res)
          }
          const fnError = (res, updateData) => {
            if (res) {
              if (updateData) {
                res.data.code = 200
                menuUtil.typeMethod.updateFormData(that, rowMenu, { response: res })
              }
              if (that?.store && that?.$options?.name === 'panguFormPage') {
                that.store.commit('setResErrors', res.data.errors)
              } else {
                that.responseData = res.data
                if (that.dispatch)
                  that.dispatch('crudEditOrder', 'on-errors-change', that.responseData)
              }
            }
          }
          let fnPromise = fn(that, rowMenu, compileVariableData, fnSuccess, fnError)
          if (fnPromise) fnPromise.then(fnSuccess).catch(fnError)
        })
      }

      var errorFn = function () {
        that.$Message.error('请完善必填信息!')
      }

      if (rowMenu.type == 'submitFormData' || rowMenu.type == 'handleSubmitFormDataBefore') {
        // 异步校验
        if (that.validate) {
          that.validate(successFn, errorFn)
        } else {
          alert('error:this._fCreateApi is null.')
        }
      } else {
        successFn()
      }
    },
  },
}

/**

2个使用场景
查询界面，按钮点击事件。（2个区域：工具栏菜单,行级菜单）
编辑货详情页，内置table，按钮事件。（（2个区域：工具栏菜单,行级菜单）
*/
var crudQueryMenuClick = {
  methods: {
    // 前置动作
    handleMenuClickActionBefore(rowMenu, data, callback) {
      return new Promise((resolve) => {
        let beforeAction = rowMenu.beforeAction ? menuUtil.typeMethod[rowMenu.beforeAction] : null
        if (!beforeAction) {
          resolve(data)
          return false
        } else {
          let beforeRowMenu = {
            param: rowMenu.beforeProperty,
            requestParam: rowMenu.beforeParameter,
          }
          var that = this.parentVue ? this.parentVue : this
          const beforeSuccess = (res) => {
            data.responseBefore = res
            resolve(data)
          }
          const beforeError = (res) => {
            if (res) that.responseData = res.data
          }

          let beforePromise = beforeAction(
            this,
            beforeRowMenu,
            data,
            (res) => {
              data.responseBefore = res
              callback(data)
            },
            beforeError
          )
          if (beforePromise) beforePromise.then(beforeSuccess).catch(beforeError)
        }
      })
    },
    // 菜单动作执行成功后，回调钩子函数
    handleMenuClickActionAfter(rowMenu, compileVariableData) {
      // if (!rowMenu.afterAction) return;
      // var afterActionDef = this.getAfterActionDef();
      // var afterActionFN = afterActionDef[rowMenu.afterAction];
      // if (typeof afterActionFN == 'function') {
      //     afterActionFN(rowMenu,  compileVariableData, res);
      // }
      let afterAction = rowMenu.afterAction ? menuUtil.typeMethod[rowMenu.afterAction] : null
      if (!afterAction) {
        return false
      }
      let afterRowMenu = {
        param: rowMenu.afterProperty,
        requestParam: rowMenu.afterParameter,
      }
      var that = this.parentVue ? this.parentVue : this
      const actionSuccess = function (res) {
        compileVariableData.responseAfter = res
      }
      const actionError = function (res) {
        if (res) that.responseData = res.data
      }
      let afterPromise = afterAction(
        this,
        afterRowMenu,
        compileVariableData,
        actionSuccess,
        actionError
      )

      if (afterPromise) afterPromise.then(actionSuccess).catch(actionError)
    },
    // 查询界面，工具栏菜单点击处理
    handleMenuClickOfToolbar(rowMenu, fromData, extendData = null) {
      var fn = menuUtil.typeMethod[rowMenu.type]
      if (!fn) {
        alert('该类型操作还未定义：rowMenu.type=' + rowMenu.type)
        return
      }

      var data = compileVariableUtil.getCompileVariable(fromData, this, extendData)
      var that = this.parentVue ? this.parentVue : this

      const beforeSuccess = (compileVariableData) => {
        const fnSuccess = (res) => {
          data.response = res
          if (res && res.data && res.data.data && res.data.code) {
            data.responseData = res.data.data
          }

          this.handleMenuClickActionAfter(rowMenu, data, res)
        }
        const fnError = (res, updateData) => {
          if (res) {
            if (updateData) {
              res.data.code = 200
              menuUtil.typeMethod.updateFormData(this, rowMenu, { response: res })
            }
            that.responseData = res.data // #6600
          }
        }

        let fnPromise = fn(this, rowMenu, compileVariableData, fnSuccess, fnError)
        if (fnPromise) fnPromise.then(fnSuccess).catch(fnError)
      }
      this.handleMenuClickActionBefore(rowMenu, data, beforeSuccess).then(beforeSuccess)
    },
    // 查询界面，行级菜单点击处理
    handleMenuClickOfRow($index, row, rowMenu, extendData) {
      var fn = menuUtil.typeMethod[rowMenu.type]
      if (!fn) {
        alert('该类型操作还未定义：rowMenu.type=' + rowMenu.type)
        return
      }
      var data = compileVariableUtil.getCompileVariable(row, this, extendData)
      this.handleMenuClickActionBefore(rowMenu, data).then((compileVariableData) => {
        const fnSuccess = (res) => {
          data.response = res
          if (res && res.data && res.data.data && res.data.code) {
            data.responseData = res.data.data
          }
          this.handleMenuClickActionAfter(rowMenu, data, res)
        }
        const fnError = (res, updateData) => {
          if (res) {
            if (updateData) {
              res.data.code = 200
              menuUtil.typeMethod.updateFormData(this, rowMenu, { response: res })
            }
            this.responseData = res.data
          }
        }
        let fnPromise = fn(this, rowMenu, compileVariableData, fnSuccess, fnError)
        if (fnPromise) fnPromise.then(fnSuccess).catch(fnError)
      })
    },
  },
}

/**
crudArray/crudArrayOrder，按钮点击事件。（2个区域：表格顶部按钮）
*/
var crudArrayMenuClick = {
  methods: {
    // 前置动作
    handleMenuClickActionBefore(rowMenu, data) {
      return new Promise((resolve) => {
        let beforeAction = rowMenu.beforeAction ? menuUtil.typeMethod[rowMenu.beforeAction] : null
        if (!beforeAction) {
          resolve(data)
          return false
        } else {
          let beforeRowMenu = {
            param: rowMenu.beforeProperty,
            requestParam: rowMenu.beforeParameter,
          }
          var that = this.parentVue ? this.parentVue : this
          const beforeSuccess = (res) => {
            data.responseBefore = res
            resolve(data)
          }
          const beforeError = (res) => {
            if (res) that.responseData = res.data
          }
          let beforePromise = beforeAction(this, beforeRowMenu, data, beforeSuccess, beforeError)
          if (beforePromise) beforePromise.then(beforeSuccess).catch(beforeError)
        }
      })
    },
    // 菜单动作执行成功后，回调钩子函数
    handleMenuClickActionAfter(rowMenu, compileVariableData) {
      // if (!rowMenu.afterAction) return;
      // var afterActionDef = this.getAfterActionDef();
      // var afterActionFN = afterActionDef[rowMenu.afterAction];
      // if (typeof afterActionFN == 'function') {
      //     afterActionFN(rowMenu, compileVariableData, res);
      // }
      let afterAction = rowMenu.afterAction ? menuUtil.typeMethod[rowMenu.afterAction] : null
      if (!afterAction) {
        return false
      }
      let afterRowMenu = {
        param: rowMenu.afterProperty,
        requestParam: rowMenu.afterParameter,
      }
      var that = this.parentVue ? this.parentVue : this
      const actionSuccess = function (res) {
        compileVariableData.responseAfter = res
      }
      const actionError = function (res) {
        if (res) that.responseData = res.data
      }
      let afterPromise = afterAction(
        this,
        afterRowMenu,
        compileVariableData,
        actionSuccess,
        actionError
      )
      if (afterPromise) afterPromise.then(actionSuccess).catch(actionError)
    },
    // 查询界面，工具栏菜单点击处理2
    handleMenuClickOfToolbar(rowMenu, fromData, extendData = null, isDropdownName) {
      // isDropdown表示如果是下拉菜单的点击事件就是点击的按钮文字
      var fn = menuUtil.typeMethod[rowMenu.type]
      if (!fn) {
        alert('该类型操作还未定义：rowMenu.type=' + rowMenu.type)
        return
      }

      var data = compileVariableUtil.getCompileVariable(fromData, this, extendData)
      const fnSuccess = (res) => {
        data.response = res
        if (res && res.data && res.data.errors) {
          this.dispatch('dynamicFrom', 'on-table-button-errors', res.data)
        }
        if (res && res.data && res.data.data && res.data.code) {
          data.responseData = res.data.data
        }
        if (isDropdownName) {
          if (this.editChoiceName && (!rowMenu.param || !rowMenu.param.noReplace)) {
            this.editChoiceName('start', rowMenu, isDropdownName)
          } else if (this.remerberSelectedBtn) {
            // 下拉按钮 code 用于，购物车模型 ALL 表示全部数据 SELECTED 表示选中的数据按钮 在静态数据配置进去
            this.remerberSelectedBtn(rowMenu.param.dorpBtnCode || null)
          }
        }
        this.handleMenuClickActionAfter(rowMenu, data, res)
      }
      const fnError = (res, updateData) => {
        if (res && res.data && res.data.errors) {
          this.dispatch('dynamicFrom', 'on-table-button-errors', res.data)
        }
        if (updateData) {
          if (!rowMenu.param.updateFormData || rowMenu.param.updateFormData === 'updateFormData')
            res.data.code = 200
          menuUtil.typeMethod[rowMenu.param.updateFormData || 'updateFormData'](this, rowMenu, {
            response: res,
          })
        }
      }
      this.handleMenuClickActionBefore(rowMenu, data).then((compileVariableData) => {
        let fnPromise = fn(this, rowMenu, compileVariableData, fnSuccess, fnError)
        if (fnPromise) fnPromise.then(fnSuccess).catch(fnError)
      })
    },

    // 表格上方按钮点击事件
    handleMenuClickOfRow($index, row, rowMenu, extendData = null) {
      var fn = menuUtil.typeMethod[rowMenu.type]
      if (!fn) {
        alert('该类型操作还未定义：rowMenu.type=' + rowMenu.type)
        return
      }

      var data = compileVariableUtil.getCompileVariable(row, this, { index: $index, ...extendData })
      const fnSuccess = (res) => {
        data.response = res
        if (res && res.data && res.data.data && res.data.code) {
          data.responseData = res.data.data
        }
        this.handleMenuClickActionAfter(rowMenu, data, res)
      }
      const fnError = (res, updateData) => {
        if (res && res.data && res.data.errors) {
          this.dispatch('dynamicFrom', 'on-table-button-errors', res.data)
        }
        if (res) {
          if (updateData) {
            res.data.code = 200
            menuUtil.typeMethod.updateFormData(this, rowMenu, { response: res })
          }
          this.responseData = res.data
        }
      }
      this.handleMenuClickActionBefore(rowMenu, data).then((compileVariableData) => {
        let fnPromise = fn(this, rowMenu, compileVariableData, fnSuccess, fnError)
        if (fnPromise) fnPromise.then(fnSuccess).catch(fnError)
      })
    },
  },
}

/**
按钮类
*/
var buttonClass = {
  methods: {
    /**
     * 获取按钮类
     * @param {string} buttonDefind 表达式
     * @param {string} data 数据
     */
    getButtonClass(buttonDefind, data, type, extendData = null, showTopBtn) {
      var preClassType = {
        TOP: 'pg-custome__queryToolbar-',
        ROW: 'pg-custome__row-',
        EDIT: 'pg-custome__editBtnGroup-',
        crudArrayTOP: 'pg-custome__crudArrayTOP-',
      }
      var classArray = []
      var eStyleClass = ''
      // 1.获取是否禁用样式
      var edisabledClass = !this.computeExpress(buttonDefind.enableExp, data, true, extendData)
      if (edisabledClass) {
        edisabledClass = preClassType[type] + 'disable'
        classArray.push(edisabledClass)
      } else {
        // 2.根据配置获取指定样式
        if (buttonDefind.style) {
          const topBtn = showTopBtn ? 'top-' : ''
          eStyleClass = preClassType[type] + topBtn + buttonDefind.style
          classArray.push(eStyleClass)
        }
      }
      return classArray
    },
  },
}

export { crudEditMenuClick, crudQueryMenuClick, menuCommon, buttonClass, crudArrayMenuClick }
